import { SoftphoneCallState, SoftphoneRegistrationState } from "@/contexts/SoftphoneContext";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import classNames from "classnames";

interface IProps {
  extensionNumber: string | null;
  registrationState: SoftphoneRegistrationState;
  callState: SoftphoneCallState;
  hasIncomingCall: boolean;
  callCount?: number;
  hasActiveCall?: boolean;
  expanded: boolean;
  onToggle: () => void;
}

function statusFor(
  registrationState: SoftphoneRegistrationState,
  callState: SoftphoneCallState,
  hasIncomingCall: boolean
): { dotClass: string; label: string } {
  if (hasIncomingCall) return { dotClass: "is-ringing", label: "Appel entrant…" };
  if (registrationState === "error") return { dotClass: "is-error", label: "Erreur de connexion" };
  if (registrationState === "connecting") return { dotClass: "is-connecting", label: "Connexion…" };
  if (registrationState === "disconnected") return { dotClass: "is-offline", label: "Déconnecté" };
  if (callState === "calling") return { dotClass: "is-ringing", label: "Appel en cours…" };
  if (callState === "in-call") return { dotClass: "is-ringing", label: "En communication" };
  return { dotClass: "is-ready", label: "Prêt" };
}

const WebphoneHeader: FC<IProps> = ({
  extensionNumber,
  registrationState,
  callState,
  hasIncomingCall,
  callCount = 0,
  hasActiveCall = false,
  expanded,
  onToggle,
}) => {
  const { dotClass, label: baseLabel } = statusFor(registrationState, callState, hasIncomingCall);

  const label = callCount > 0 && !hasActiveCall && !hasIncomingCall ? "Appels en attente" : baseLabel;
  return (
    <div
      className="d-flex align-items-center px-3 py-2 cursor-pointer"
      role="button"
      tabIndex={0}
      aria-expanded={expanded}
      aria-label="Afficher ou réduire le téléphone"
      onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onToggle(); } }}
      onClick={onToggle}
    >
      <span className={classNames("webphone-status-dot", dotClass)} />
      <span className="ms-2 fs--1 fw-semi-bold">
        {extensionNumber ? `Poste ${extensionNumber}` : "Softphone"}
      </span>
      <span className="mx-1 text-body-tertiary">·</span>
      <span className="fs--1 text-body-secondary">{label}</span>
      {callCount > 0 && <span className="badge bg-primary ms-2" aria-label={`${callCount} appel${callCount > 1 ? "s" : ""}`}>{callCount}</span>}
      <FontAwesomeIcon
        icon={expanded ? faChevronDown : faChevronUp}
        className="ms-auto text-body-tertiary"
      />
    </div>
  );
};

export default WebphoneHeader;
